import { Injectable, OnDestroy, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

/** Paginator labels ("Items per page", "1 – 10 of 6746", button tooltips) in the active language. */
@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private readonly transloco = inject(TranslocoService);
  private readonly langSub: Subscription;

  constructor() {
    super();
    this.langSub = this.transloco.langChanges$.subscribe(() => this.setLabels());
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.transloco.translate('paginator.rangeEmpty', { length });
    }
    const start = page * pageSize;
    const end = Math.min(start + pageSize, length);
    return this.transloco.translate('paginator.range', { start: start + 1, end, length });
  };

  private setLabels(): void {
    // Plain translate() is safe: the startup initializer and LanguageService.setLanguage load a language before it's active
    this.itemsPerPageLabel = this.transloco.translate('paginator.itemsPerPage');
    this.nextPageLabel = this.transloco.translate('paginator.nextPage');
    this.previousPageLabel = this.transloco.translate('paginator.previousPage');
    this.firstPageLabel = this.transloco.translate('paginator.firstPage');
    this.lastPageLabel = this.transloco.translate('paginator.lastPage');
    this.changes.next();
  }

  ngOnDestroy(): void {
    this.langSub.unsubscribe();
  }
}
